import { SupportedLanguage } from 'hyarchis-global/i18n/types';

const getAssetsConfig = () => ({
  SETTINGS_ICON: 'assets/wrench.svg',
  LOGO_TOP_BAR: 'assets/logo-top-bar.svg',
  LOGO_LOGIN: 'assets/logo-login.svg',
  BACKGROUND_IMAGE_HIGH_RES: 'assets/login-background.svg',
  BACKGROUND_IMAGE_LOW_RES: 'assets/login-background.svg',
});

export const ASSETS = getAssetsConfig();
export const DEFAULT_DRAWER_WIDTH = 550;
export const DEFAULT_LANGUAGE = SupportedLanguage.English;
export const DEPLOYMENT_PATH = '/';
export const MAX_FILE_SIZE = 104857600;
export const MODAL_DISCARD_BUTTON_COLOR = '#F13D4A';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const COLOR_SUCCESS = 'green';
export const COLOR_WARNING = 'orange';
export const COLOR_FAILURE = 'red';
export const COLOR_INACTIVE = 'light-grey';
